var $780747bb2d5cd760$exports = {};
$780747bb2d5cd760$exports = {
    "loading": `\u{8AAD}\u{307F}\u{8FBC}\u{307F}\u{4E2D}...`,
    "placeholder": `\u{9078}\u{629E}\u{2026}`
};


export {$780747bb2d5cd760$exports as default};
//# sourceMappingURL=ja-JP.mjs.map
